<template>
  <div>
    <content-placeholders>
      <content-placeholders-heading class="my-4" />
      <JoszakiCard class="grid grid-cols-[auto_1fr] gap-2 mt-5">
        <content-placeholders-img
          class="!h-9 !w-9 [clip-path:circle(50%_at_50%_50%)]"
        />
        <div>
          <content-placeholders-heading />
          <content-placeholders-text :lines="2" />
        </div>
      </JoszakiCard>
    </content-placeholders>
  </div>
</template>

<script>
export default {
  name: "CardQuestionDetailsPlaceholder",
};
</script>
